import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'h_team',
} as IModuleProps;
